<template>
  <div class="row">
    <div v-if="campaigns.length" class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body border-0 py-5">
          <div class="card-toolbar">
            <div class="col-lg-12 col-xxl-12 p-0">
              <div class="card card-custom gutter-b p-5">
                <div class="row">
                  <div class="col-lg-4 align-self-center">
                    <b-form-group
                      id="name-input-group"
                      class="mb-0"
                      label="เลือกแคมเปญ"
                      label-for="name-input"
                      label-cols="3"
                      label-align-sm="left"
                      label-size="lg"
                    >
                      <model-select
                        :options="campaigns_option"
                        v-model="item"
                        placeholder=""
                        @input="onSelect"
                      >
                      </model-select>
                    </b-form-group>
                  </div>
                  <div class="col-lg-2 align-self-center text-center">
                    <span v-if="campaign_id" class="status-campaign"
                      >สถานะ
                    </span>
                    <span
                      v-if="campaign_id"
                      class="status-campaign"
                      :class="campaign.is_active ? 'active' : 'deactive'"
                      >{{ campaign.is_active ? "เปิด" : "ปิด" }}</span
                    >
                    <!-- <span style="color:red;font-weight:bold;">ปิด</span> -->
                  </div>
                  <div class="col-lg-3 align-self-center text-center">
                    <span
                      v-if="campaign_id"
                      style="text-decoration: underline; font-weight: bold"
                      >เริ่มต้น {{ displayStartDate }}
                    </span>
                    <!-- <span style="color:red;font-weight:bold;">ปิด</span> -->
                  </div>
                  <div class="col-lg-3 align-self-center text-center">
                    <span
                      v-if="campaign_id"
                      style="text-decoration: underline; font-weight: bold"
                      >สิ้นสุด {{ displayEndDate }}
                    </span>
                    <!-- <span style="color:red;font-weight:bold;">ปิด</span> -->
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-8">
              <div class="col-lg-12 col-xxl-12">
                <CampaignDashboard
                  v-if="campaign_id"
                  :key="`dashboard-${campaign_id}`"
                  :campaign_id="campaign_id"
                  :start_date="campaign.start_date"
                  :plan_slug="dashboardCampaignPlanSlug"
                  :end_date="campaign.end_date"
                  :is_redeem_reward="campaign.is_redeem_reward"
                  :template="campaign.template"
                  :is_pro_plan="isProPlanForDashboard"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="col-lg-12 col-xxl-12">
      <div class="card card-custom card-stretch gutter-b">
        <div class="card-body p-5 border-0">
          <div class="card-toolbar">
            <div class="p-5 text-center">
              <h2>ยังไม่มีข้อมูลกิจกรรม</h2>

              <div class="mt-5">
                <a href="/#/campaign/form/campaign_receipt"
                  >สร้างข้อมูลกิจกรรม</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_CAMPAIGN /* FIND_CAMPAIGN  */
} from "@/core/services/store/campaign.module";
import { GET_COMPANY_MANAGEMENT_DATA } from "@/core/services/store/company_management.module";
import Swal from "sweetalert2";
import { ModelSelect } from "vue-search-select";
import CampaignDashboard from "@/view/pages/campaign/campaign-receipt-form/components/CampaignDashboard.vue";

export default {
  name: "Dashboard",
  components: {
    ModelSelect,
    CampaignDashboard
  },
  data() {
    return {
      campaign_id: null,
      item: {
        value: "",
        text: ""
      },
      campaigns: [],
      campaign: {},
      campaigns_option: [],
      /** จาก FIND_CAMPAIGN — ให้สอดคล้องกับ CampaignReceiptForm (plan_slug จาก PlanService) */
      dashboardCampaignPlanSlug: null
    };
  },
  computed: {
    /** แสดงผลเท่านั้น — อย่าเขียนทับ campaign.start_date เป็น string ไทย (ทำให้ CampaignDashboard new Date() พัง) */
    displayStartDate() {
      return this.formatDateForDisplay(
        this.campaign && this.campaign.start_date
      );
    },
    displayEndDate() {
      return this.formatDateForDisplay(this.campaign && this.campaign.end_date);
    },
    /** เหมือน isProPlanForMembersTab ใน CampaignReceiptForm — Pro เท่านั้น (กราฟ/Export แบบ Pro) */
    isProPlanForDashboard() {
      const raw = this.dashboardCampaignPlanSlug;
      if (raw === null || raw === undefined || raw === "") {
        return false;
      }
      return String(raw).toLowerCase().trim() === "pro";
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: `${this.$t("MENU.DASHBOARD.TITLE")}` }
    ]);
    this.getCampaignAll();
  },
  methods: {
    formatDateForDisplay(value) {
      if (value == null || value === "") return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      return date.toLocaleDateString(["th-TH"], {
        month: "short",
        day: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit"
      });
    },
    onSelect(e) {
      Swal.fire({
        title: `${this.$t("LOADING")}`,
        allowEscapeKey: false,
        allowOutsideClick: false,
        timer: 36000,
        onOpen: async () => {
          Swal.showLoading();
          await this.setDataGraph(e.value);
          Swal.close();
        }
      });
    },
    async syncCompanyPlanSlug(companyId) {
      if (!companyId) {
        this.dashboardCampaignPlanSlug = null;
        return;
      }
      try {
        const { data } = await this.$store.dispatch(
          GET_COMPANY_MANAGEMENT_DATA,
          {
            id: companyId
          }
        );
        if (
          data.status === "success" &&
          data.data &&
          data.data.plan_slug != null &&
          data.data.plan_slug !== ""
        ) {
          this.dashboardCampaignPlanSlug = data.data.plan_slug;
        } else {
          this.dashboardCampaignPlanSlug = "starter";
        }
      } catch (e) {
        this.dashboardCampaignPlanSlug = null;
      }
    },

    /*     async syncCampaignPlanSlug(campaignId) {
      if (!campaignId) {
        this.dashboardCampaignPlanSlug = null;
        return;
      }
      try {
        const { data } = await this.$store.dispatch(FIND_CAMPAIGN, {
          id: campaignId,
        });
        if (
          data.status === "success" &&
          data.data &&
          data.data.plan_slug != null &&
          data.data.plan_slug !== ""
        ) {
          this.dashboardCampaignPlanSlug = data.data.plan_slug;
        } else {
          this.dashboardCampaignPlanSlug = "starter";
        }
      } catch (e) {
        this.dashboardCampaignPlanSlug = null;
      }
    }, */
    async setDataGraph(campaign_id) {
      this.campaign_id = campaign_id;
      this.campaign = JSON.parse(
        JSON.stringify(
          this.campaigns.filter((data) => data.id == this.campaign_id)[0]
        )
      );

      await this.syncCompanyPlanSlug(this.campaign.company_id);
    },
    async getCampaignAll() {
      this.$store
        .dispatch(GET_CAMPAIGN, {})
        .then(async ({ data }) => {
          if (data.status === "success" && data.data) {
            this.campaigns = data.data;

            if (this.campaigns.length) {
              this.item.value = this.campaigns[0].id;
              await this.setDataGraph(this.campaigns[0].id);
              for (const campaign of data.data) {
                this.campaigns_option.push({
                  value: campaign.id,
                  text: campaign.name
                });
              }
            }
          } else if (data.status === "error" && data.error) {
            Swal.fire({
              icon: "error",
              text: `${this.$t("RESPONSE_MESSAGE." + data.error)}`,
              confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
            });
          }
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            text: `${error}`,
            confirmButtonText: `${this.$t("PAGE.DEFAULT.FORM.BTN_OK")}`
          });
        });
    }
  }
};
</script>

<style scoped lang="scss">
span {
  font-size: 16px;
}

.status-campaign {
  font-weight: bold;
}

.active {
  color: green;
}

.deactive {
  color: red;
}
</style>
